const DefaultState = {
  sizeField: '', //prop by wich to calculate piechart circle radius
  chartKey: '' //field by wich to divide pie sections
}

export const indicatorFields = ['OCE_grupa', 'dabas_grup', 'kartot_gr', 'pamat_grup', 'kartot2_gr', 'noslodze_g', 'alga_grupa', 'attiecib2', 'otrgad_gr'];


const sharemap = (state = DefaultState, action) => {
  switch (action.type) {
     case UPDATE_CHART_KEY:
     
      state.chartKey = action.data;

      return Object.assign({}, state);
    case UPDATE_SIZE_FIELD:

      state.sizeField = action.data;
      
      return Object.assign({}, state);  
    default:
      return state;
  }
}



export {sharemap}


// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/schoolQualityIndicators/reducer.js